import type { Enum_TariffLine_3 } from '@flows/insurance/types/products/de'

export const FAILURE_STEP_NAME = 'failure'
export const MINIMUM_CUSTOMER_AGE = {
  de: 18,
  at: 18,
}
export const MAXIMUM_CUSTOMER_AGE = {
  de: 90,
  at: 90,
}

export const TARIFF_LINE_OPTIONS: Record<string, Enum_TariffLine_3> = {
  PREMIUM: 'premium',
  COMFORT: 'comfort',
}
